import React from 'react';
import './Spinner.css'; // 스타일 시트 임포트

const LoadingSpinner = (): JSX.Element => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingSpinner;
